import './App.css';
import Company from "./Company";

function App() {
    const hostname = window.location.hostname.split('.')[0]
    // console.log(hostname)
    return (
        /*<div className="App">
            {hostname === "demo" && <MyForm/>}
            {hostname !== "demo" && <Company company={hostname}/>}
        </div>*/

        <div className="App">
            <Company company={hostname}/>
        </div>
    );
}

export default App;
